"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1946,1917,265],{

/***/ 70265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Button = function Button(_ref) {
  var link = _ref.link,
      onSubmit = _ref.onSubmit,
      text = _ref.text,
      src = _ref.src,
      img = _ref.img,
      hoverImg = _ref.hoverImg,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      margin = _ref.margin,
      background = _ref.background,
      borderRadius = _ref.borderRadius,
      border = _ref.border,
      width = _ref.width,
      height = _ref.height,
      hoverBackground = _ref.hoverBackground,
      target = _ref.target,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      icon = _ref.icon,
      nolink = _ref.nolink;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBtn, {
    className: "dc-btn ",
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    background: background,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    margin: margin,
    border: border,
    img: img,
    borderRadius: borderRadius,
    width: width,
    hoverImg: hoverImg,
    hoverBackground: hoverBackground,
    height: height,
    borderColor: borderColor,
    target: target,
    hoverColor: hoverColor,
    onSubmit: onSubmit,
    children: src ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: src || '/',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now_2",
          "data-name": "Button - Open an Account Now 2",
          width: "256",
          height: "44",
          viewBox: "0 0 256 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "".concat(color ? color : 'white'),
            strokeWidth: "1",
            opacity: "0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "256",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "255",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "".concat(color ? color : 'white'),
            strokeWidth: "1",
            strokeDasharray: "1 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "256",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "255",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Group_4825",
            "data-name": "Group 4825",
            transform: "translate(36 12)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
              id: "Open_an_Account_Now",
              "data-name": "Open an Account Now",
              transform: "translate(0 15)",
              fill: "".concat(color ? color : 'white'),
              "font-size": "16",
              "font-family": "Avenir-Medium, Avenir",
              "font-weight": "500",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
                x: "0",
                y: "0",
                children: text
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_4824",
              "data-name": "Group 4824",
              transform: "translate(174 4.5)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
                id: "Group_4823",
                "data-name": "Group 4823",
                transform: "translate(5)",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                  id: "Line_9",
                  "data-name": "Line 9",
                  x2: "5",
                  y2: "5",
                  fill: "none",
                  stroke: "".concat(color ? color : 'white'),
                  strokeLinecap: "round",
                  strokeWidth: "1"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                  id: "Line_10",
                  "data-name": "Line 10",
                  x1: "5",
                  y2: "5",
                  transform: "translate(0 5)",
                  fill: "none",
                  stroke: "".concat(color ? color : 'white'),
                  strokeLinecap: "round",
                  strokeWidth: "1"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_11",
                "data-name": "Line 11",
                x2: "10",
                transform: "translate(0 5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              })]
            })]
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now",
          "data-name": "Button - Open an Account Now",
          xmlns: "http://www.w3.org/2000/svg",
          width: "238",
          height: "44",
          viewBox: "0 0 238 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            opacity: "0.3",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            strokeDasharray: "2 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Open_an_Account_Now",
            "data-name": "Open an Account Now",
            transform: "translate(36 27)",
            fill: "#fff",
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "0",
              y: "0",
              children: text
            })
          })]
        })
      })
    }) : link ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: link,
      target: '_blank',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now_2",
          "data-name": "Button - Open an Account Now 2",
          width: "256",
          height: "44",
          viewBox: "0 0 256 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "".concat(color ? color : 'white'),
            strokeWidth: "1",
            opacity: "0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "256",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "255",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "".concat(color ? color : 'white'),
            strokeWidth: "1",
            strokeDasharray: "1 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "256",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "255",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Group_4825",
            "data-name": "Group 4825",
            transform: "translate(36 12)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
              id: "Open_an_Account_Now",
              "data-name": "Open an Account Now",
              transform: "translate(0 15)",
              fill: "".concat(color ? color : 'white'),
              "font-size": "16",
              "font-family": "Avenir-Medium, Avenir",
              "font-weight": "500",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
                x: "0",
                y: "0",
                children: text
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_4824",
              "data-name": "Group 4824",
              transform: "translate(174 4.5)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
                id: "Group_4823",
                "data-name": "Group 4823",
                transform: "translate(5)",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                  id: "Line_9",
                  "data-name": "Line 9",
                  x2: "5",
                  y2: "5",
                  fill: "none",
                  stroke: "".concat(color ? color : 'white'),
                  strokeLinecap: "round",
                  strokeWidth: "1"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                  id: "Line_10",
                  "data-name": "Line 10",
                  x1: "5",
                  y2: "5",
                  transform: "translate(0 5)",
                  fill: "none",
                  stroke: "".concat(color ? color : 'white'),
                  strokeLinecap: "round",
                  strokeWidth: "1"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_11",
                "data-name": "Line 11",
                x2: "10",
                transform: "translate(0 5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              })]
            })]
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now",
          "data-name": "Button - Open an Account Now",
          xmlns: "http://www.w3.org/2000/svg",
          width: "238",
          height: "44",
          viewBox: "0 0 238 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            opacity: "0.3",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            strokeDasharray: "2 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Open_an_Account_Now",
            "data-name": "Open an Account Now",
            transform: "translate(36 27)",
            fill: "#fff",
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "0",
              y: "0",
              children: text
            })
          })]
        })
      })
    }) : nolink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: 'javascript:void(0)',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now_2",
          "data-name": "Button - Open an Account Now 2",
          width: "256",
          height: "44",
          viewBox: "0 0 256 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "".concat(color ? color : 'white'),
            strokeWidth: "1",
            opacity: "0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "256",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "255",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "".concat(color ? color : 'white'),
            strokeWidth: "1",
            strokeDasharray: "1 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "256",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "255",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Group_4825",
            "data-name": "Group 4825",
            transform: "translate(36 12)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
              id: "Open_an_Account_Now",
              "data-name": "Open an Account Now",
              transform: "translate(0 15)",
              fill: "".concat(color ? color : 'white'),
              "font-size": "16",
              "font-family": "Avenir-Medium, Avenir",
              "font-weight": "500",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
                x: "0",
                y: "0",
                children: text
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_4824",
              "data-name": "Group 4824",
              transform: "translate(174 4.5)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
                id: "Group_4823",
                "data-name": "Group 4823",
                transform: "translate(5)",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                  id: "Line_9",
                  "data-name": "Line 9",
                  x2: "5",
                  y2: "5",
                  fill: "none",
                  stroke: "".concat(color ? color : 'white'),
                  strokeLinecap: "round",
                  strokeWidth: "1"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                  id: "Line_10",
                  "data-name": "Line 10",
                  x1: "5",
                  y2: "5",
                  transform: "translate(0 5)",
                  fill: "none",
                  stroke: "".concat(color ? color : 'white'),
                  strokeLinecap: "round",
                  strokeWidth: "1"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_11",
                "data-name": "Line 11",
                x2: "10",
                transform: "translate(0 5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              })]
            })]
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now",
          "data-name": "Button - Open an Account Now",
          xmlns: "http://www.w3.org/2000/svg",
          width: "238",
          height: "44",
          viewBox: "0 0 238 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            opacity: "0.3",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            strokeDasharray: "2 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Open_an_Account_Now",
            "data-name": "Open an Account Now",
            transform: "translate(36 27)",
            fill: "#fff",
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "0",
              y: "0",
              children: text
            })
          })]
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: src || '',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now_2",
          "data-name": "Button - Open an Account Now 2",
          width: "256",
          height: "44",
          viewBox: "0 0 256 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "".concat(color ? color : 'white'),
            strokeWidth: "1",
            opacity: "0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "256",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "255",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "".concat(color ? color : 'white'),
            strokeWidth: "1",
            strokeDasharray: "1 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "256",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "255",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Group_4825",
            "data-name": "Group 4825",
            transform: "translate(36 12)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
              id: "Open_an_Account_Now",
              "data-name": "Open an Account Now",
              transform: "translate(0 15)",
              fill: "".concat(color ? color : 'white'),
              "font-size": "16",
              "font-family": "Avenir-Medium, Avenir",
              "font-weight": "500",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
                x: "0",
                y: "0",
                children: text
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_4824",
              "data-name": "Group 4824",
              transform: "translate(174 4.5)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
                id: "Group_4823",
                "data-name": "Group 4823",
                transform: "translate(5)",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                  id: "Line_9",
                  "data-name": "Line 9",
                  x2: "5",
                  y2: "5",
                  fill: "none",
                  stroke: "".concat(color ? color : 'white'),
                  strokeLinecap: "round",
                  "stroke-width": "1"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                  id: "Line_10",
                  "data-name": "Line 10",
                  x1: "5",
                  y2: "5",
                  transform: "translate(0 5)",
                  fill: "none",
                  stroke: "".concat(color ? color : 'white'),
                  strokeLinecap: "round",
                  "stroke-width": "1"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_11",
                "data-name": "Line 11",
                x2: "10",
                transform: "translate(0 5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                "stroke-width": "1"
              })]
            })]
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now",
          "data-name": "Button - Open an Account Now",
          xmlns: "http://www.w3.org/2000/svg",
          width: "238",
          height: "44",
          viewBox: "0 0 238 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "#fff",
            "stroke-width": "1",
            opacity: "0.3",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "#fff",
            "stroke-width": "1",
            strokeDasharray: "2 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Open_an_Account_Now",
            "data-name": "Open an Account Now",
            transform: "translate(36 27)",
            fill: "#fff",
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "0",
              y: "0",
              children: text
            })
          })]
        })
      })
    })
  });
};

var StyledBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ButtonOpenNow__StyledBtn",
  componentId: "sc-11pootq-0"
})(["&.dc-btn{margin:", ";width:", ";height:", "px;cursor:pointer;a{display:flex;width:fit-content;height:100%;align-items:center;justify-content:center;font-size:", "px;font-weight:", ";margin:0;line-height:", "px;background-color:", ";position:relative;border-radius:", "px;overflow:hidden;z-index:0;transition:border 1s cubic-bezier(.25,.74,.22,.99);box-sizing:border-box;color:", ";svg{width:auto;height:100%;#Rectangle_493{transition:all 1s cubic-bezier(.25,.74,.22,.99);}}span{transition:color 1s cubic-bezier(.25,.74,.22,.99);color:", ";position:relative;margin-top:5px;z-index:2;line-height:45px;}@keyframes dash{from{stroke-dashoffset:0;}to{stroke-dashoffset:590px;}}&:hover{svg{line{stroke:", ";}#Rectangle_493{opacity:1;strokeDasharray:590px;}}&:before{transform:translate(0);}}&:focus{color:#222222;}&:hover{color:#222222;}}.ok{position:absolute;left:0;top:0;width:100%;height:100%;overflow:visible;transform:translateX(0.25px);margin:0;rect{rx:calc(20 / 2);ry:calc(20 / 2);stroke:#3C3C3B;}}}"], function (props) {
  return props.margin || '0';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '44';
}, function (props) {
  return props.fontSize || '16';
}, function (props) {
  return props.fontWeight || 500;
}, function (props) {
  return props.lineHeight || '24';
}, function (props) {
  return props.background || "transparent";
}, function (props) {
  return props.borderRadius || '22';
}, function (props) {
  return props.color || "#3C3C3B";
}, function (props) {
  return props.color || "#3C3C3B";
}, function (props) {
  return props.hoverColor || '#FFF';
});
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Button));

/***/ }),

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 2073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31555);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68019);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93264);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30653);
/* harmony import */ var _ButtonOpenNow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70265);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var Investors = function Investors(_ref) {
  var _section_image$list, _section_image$list$, _section_image$list2, _section_image$list2$;

  var offset = _ref.offset,
      data = _ref.data,
      id = _ref.id;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_image = data === null || data === void 0 ? void 0 : data.images;
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap__WEBPACK_IMPORTED_MODULE_7__/* .gsap.to */ .p8.to('.hide', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledSecurity, {
    offset: offset,
    id: id ? id : '',
    className: "security-seal hide pt-100 pb-100",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      fluid: true,
      className: 'pl-0',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          sm: 5,
          className: "security-seal__img ",
          children: (section_image === null || section_image === void 0 ? void 0 : (_section_image$list = section_image.list) === null || _section_image$list === void 0 ? void 0 : (_section_image$list$ = _section_image$list[0]) === null || _section_image$list$ === void 0 ? void 0 : _section_image$list$.full_path) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "security-seal__img__inner reveal",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_1__/* .Img */ .E, {
              layout: 'responsive',
              src: section_image === null || section_image === void 0 ? void 0 : (_section_image$list2 = section_image.list) === null || _section_image$list2 === void 0 ? void 0 : (_section_image$list2$ = _section_image$list2[0]) === null || _section_image$list2$ === void 0 ? void 0 : _section_image$list2$.full_path,
              alt: 'Shanta Securities Limited'
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          sm: {
            span: 7
          },
          className: "security-seal__text",
          children: [(section_data === null || section_data === void 0 ? void 0 : section_data.subtitle) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_2__["default"], {
            margin: '0 0 40px',
            text: section_data === null || section_data === void 0 ? void 0 : section_data.subtitle,
            fontSize: '44',
            fontWeight: '400',
            lineHeight: '56'
          }), (section_data === null || section_data === void 0 ? void 0 : section_data.description) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.description), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonOpenNow__WEBPACK_IMPORTED_MODULE_4__["default"], {
            src: '/investment-calculator',
            text: "Investment Calculator",
            margin: "30px 0 0 0",
            background: "transparent",
            color: '#3C3C3B',
            hoverColor: '#3C3C3B',
            icon: true
          })]
        })]
      })
    })
  });
};

var StyledSecurity = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Investors__StyledSecurity",
  componentId: "sc-7nzmyl-0"
})(["background-color:#F2F2F2;padding:280px 0;.container-fluid{padding-right:", "px;}.security-seal__img{&__inner{padding-top:calc(420 / 528 * 100%);position:relative;width:100%;}}.security-seal__text{padding-left:55px;p{font-size:16px;line-height:22px;font-weight:500;color:#3C3C3B;}}@media(min-width:768px){.security-seal__text{display:flex;align-items:flex-start;flex-direction:column;justify-content:center;}}@media (max-width:991px){.container-fluid{padding-right:15px !important;padding-left:15px !important;}.security-seal__img{min-width:100%;padding:0;}.security-seal__text{min-width:100%;margin-top:60px;margin-left:0;padding-left:15px !important;padding-right:15px !important;}}@media (max-width:767px){padding:180px 0 120px !important;.dc-btn{margin-top:30px;}}.popup-click{position:relative;overflow:hidden;&:before{height:100%;width:100%;position:absolute;z-index:9;top:0;bottom:0;left:0;right:0;}}"], function (props) {
  return props.offset ? props.offset : '90';
});
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Investors));

/***/ })

}]);